import {
  GET_ACT_SHIPPING_SUCCESS,
  GET_ACT_SHIPPING_FAIL,
  ADD_ACT_SHIPPING_SUCCESS,
  ADD_ACT_SHIPPING_FAIL,
  UPDATE_ACT_SHIPPING_SUCCESS,
  UPDATE_ACT_SHIPPING_FAIL,
  DELETE_ACT_SHIPPING_SUCCESS,
  DELETE_ACT_SHIPPING_FAIL,
  SHOW_LOADING,
  HIDE_LOADING
} from './actionTypes';

const INIT_STATE = {
  actShippings: [],
  loading: false
};

const actShipping = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ACT_SHIPPING_SUCCESS:
      return {
        ...state,
        actShippings: action.payload
      };
    case GET_ACT_SHIPPING_FAIL:
      return {
        ...state,
        error: action.payload
      };
    case ADD_ACT_SHIPPING_SUCCESS:
      return {
        ...state,
        actShippings: [...state.actShippings, action.payload],
        success: { data: 'success' }
      };
    case ADD_ACT_SHIPPING_FAIL:
      return {
        ...state,
        error: action.payload
      };
    case UPDATE_ACT_SHIPPING_SUCCESS:
      return {
        ...state,
        actShippings: state.actShippings.map((service) => (service._id.toString() === action.payload._id.toString() ? { service, ...action.payload } : service)),
        success: { data: 'success' }
      };
    case UPDATE_ACT_SHIPPING_FAIL:
      return {
        ...state,
        error: action.payload
      };
    case DELETE_ACT_SHIPPING_SUCCESS:
      return {
        ...state,
        actShippings: state.actShippings.filter((service) => service._id.toString() !== action.payload._id.toString())
      };
    case DELETE_ACT_SHIPPING_FAIL:
      return {
        ...state,
        error: action.payload
      };
    case SHOW_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case HIDE_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    default:
      return state;
  }
};

export default actShipping;
